import styled from 'styled-components';
import WidgetFooter from 'app/components/atoms/WidgetFooter/WidgetFooter';

const CardFooter = styled(WidgetFooter)``;

export default CardFooter;
